<template>
  <!-- NOTE: we do not want to use the keydown:esc event because
  we need them to select an option before changing owners
  - Jordan -->
  <v-dialog
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    max-width="600"
  >
    <v-card>
      <v-card-text class="text-sm-left pb-1 pt-2">
        A new conversation will be created if one does not already exist between
        the new owners.
      </v-card-text>

      <v-card-text class="text-sm-left pb-1 pt-1">
        <strong
          >From the <i>current</i> conversation, would you like to copy the
          messages over, move the messages over, or start a new, empty
          conversation?</strong
        >
      </v-card-text>

      <v-card-text class="text-sm-left pb-1 pt-1">
        The messages from your conversation with these owner(s) would be
        copied/transferred over if you choose to do so:

        <ul class="pt-2">
          <li v-for="owner in currentOwners">{{ owner.full_name }}</li>
        </ul>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="text-capitalize secondary"
          outline
          @click="$emit('update-owners', true, false)"
        >
          Copy Messages
        </v-btn>
        <v-btn
          class="text-capitalize secondary"
          outline
          @click="$emit('update-owners', false, true)"
        >
          Move Messages
        </v-btn>
        <v-btn
          class="text-capitalize secondary"
          outline
          @click="$emit('update-owners', false, false)"
        >
          Start a New Converation
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmNewConversationDialog',
  props: {
    currentOwners: {
      type: Array,
      default: () => [],
    },
    opened: {
      required: true,
      type: Boolean,
    },
  },
};
</script>
